<template>
<div class="panel" :style="{ '--scale-factor': scaleFactor }">
  <Header/>
  <div style="position: relative">
    <img
      src="@/assets/list/banners.png"
      style="width: 100%;height: 460px"
      alt=""
    />
    <div style="position: absolute;bottom: 12px;right:150px;color: #fffffd;cursor:pointer;">
      <span @click="$router.push({ path: '/' })">首页</span> /
      <span>{{ firstMenuName }}</span> /
      <span>{{menuName}}</span>
    </div>
  </div>
  <div
    id="list"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="处理中…… 请耐心等待"
    element-loading-spinner="el-icon-loading"
  >
    <div
     class="contentBox"
    >
        <div class="left-nav" >
          <div class="titleNav">
            <div id="nav-body"  style="width: 100%;">
              <div class="bg_title">
                <p style="color: #fff;font-size:32px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{ firstMenuName }}</p>
                <p style="color: #fff;font-size:12px;">LIST</p>
              </div>
              <div v-for="(item, i) in menuList" :key="i"
              >
              <div
                @click="toList(item.id, item.label,i)"
                :class="activeMenuIndex==i?'activeBorder':'hoverBorder'"
                style="text-align: left;width:100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-top: 3px;display: flex;align-items: center;justify-content: space-between"

              >
                <p >{{ item.label }}</p>
                <img src="@/assets/list/active.png" alt="" style="width: 13px;height: 12px;margin-right: 40px" v-if="activeMenuIndex!=i">
                <img src="@/assets/list/actived.png" alt="" style="width: 13px;height: 12px;margin-right: 40px" v-else>
              </div>
                <el-divider></el-divider>
              </div>
            </div>
          </div>
        </div>
        <div
          class="rightContent"
        >
          <div class="box_card">
          <el-card
            v-for="(item, i) in contentList"
            @click.native="toDetail(item.id, item.title,i)"
            :key="i"
            :class="activeIndex==i?'active_card':'card_data'"

          >
            <img
              v-if="item.picUrl"
              @error="handleImageError"
              :src="
                  item.picUrl ? '/mainsys/UserFiles/menupic/' + item.picUrl : ''
                "
              style="height: 203px;margin: 0 auto;"
            />
            <div
              style="
                width: 100%;
                font-size: 18px;
                font-weight: 600;
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 60px;
                height: 60px;
              "
            >
              {{ item.title }}
            </div>
          </el-card>
          </div>

          <div style="width: 100%; text-align: center">
            <el-pagination
              style="text-align: center; margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 40, 50, 60]"
              :page-size="length"
              layout="total, sizes, jumper, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
    </div>
  </div>
  <!-- 底部快捷链接 -->
  <div class="bottomLink">
    <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
      <div
        v-for="(item, index) in friendshipLink.res"
        :key="index"
        class="bottomLinkList"
        :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
        @click="goLink(item)"
      >
        <div style="display:flex;align-items: center;">
          <img
            @error="handleImageError"
            :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
            style="height: 18px;width: 18px;margin-right:12px;"
          />
          <div style="line-height: 20px;height: 20px;">
            {{ item.linkName }}
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- 底部版权信息 -->
  <div class="copyDiv">
    <div style="width: 100%;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
      <div class="copyDivLeft">
        <img
          :src="require('../assets/bottomLogo.png')"
          alt=""
          style="width:360px;height:50px;margin-bottom:16px"
        />
        <div class="copyDivLeftCon">建设单位：国防科技大学</div>
        <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
        <div class="copyDivLeftCon">
          推荐使用: Chrome或Firefox等主流浏览器
        </div>
        <div class="copyDivLeftCon">
          Copyright © 1999- 2024 国防科技大学 版权所有
        </div>
        <div class="copyDivLeftCon">
          总计访问次数：{{websiteVisitsNum}} 次 <span style="margin-left: 50px">年度访问次数：{{yearCount}} 次</span>
        </div>
      </div>
      <div
        class="copyDivRight"
        style="text-align:center;width: 140px"
        v-if="friendshipLink.top && friendshipLink.top.length > 0"
      >
        <img
          @error="handleImageError"
          :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
          alt=""
          style="width:140px;height:140px;margin:0 auto;text-align: center"
        />
        <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
          {{ friendshipLink.top[0].linkName }}
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import Header from "@/views/Header.vue";
export default {
  name: "list",
  data() {
    return {
      fullscreenLoading: false,
      menuId: this.$route.params.menuId,
      firstMenuName: "",
      firstMenuId: "",
      menuList: [],
      contentList: [],
      total: 0, //总页数
      page: 1, //页码
      length: 10, //长度
      linkAddress: "", //链接地址
      activeMenuIndex: 0,
      activeIndex:0,
      menuName:"",
      websiteVisitsNum:0,
      yearCount:0,
      scaleFactor: 1, // 初始缩放比例
    };
  },
  components: {
    Header,
  },
  watch:{
    $route(newVal,oldVal){
      if(newVal.params.menuId||newVal.params.menuIndex){
        this.menuId = newVal.params.menuId;
        this.activeMenuIndex=newVal.params.menuIndex
        this.getSecondList();
      }
    }
  },
  methods: {
    handleImageError(e){
      e.target.src = require('../assets/2.png')
    },
    getAccessLogNum(){
      axios
        .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
          this.yearCount=res.data.yearCount
        }
      })
    },
    goLink(item) {
      if(item.linkName=='头歌'){
        this.$router.push({
          path: "/touGe",
          query: {url: item.linkUrl,activeIndex:null }
        });
      }else{
        if (item.linkUrl != "/") {
          if (item.linkTarget == "_blank") {
            window.open(item.linkUrl);
          } else {
            window.location.href = item.linkUrl;
          }
        }
      }

    },
    handleResize() {
      const windowWidth = window.innerWidth;
      const baseWidth = 1920; // 基准宽度
      console.log(windowWidth / baseWidth);
      this.scaleFactor = windowWidth / baseWidth
    },
    changeList(id) {
      this.menuId = id;
      this.getSecondList();
    },
    toList(menuId, label,index) {
      this.activeMenuIndex = index;
      this.menuId = menuId;
      this.getSecondList();
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.length = val;
      this.page = 1;
      this.getSecondList();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.page = val;
      this.getSecondList();
    },
    getSecondList() {
      this.fullscreenLoading = true;
      let fd = new FormData();
      fd.append("page", this.page);
      fd.append("num", this.length);
      var choosedItem = {};
      axios
        .post('/cmsapi/menus/' + this.menuId, fd, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((response) => {
          var recData = response.data;
          if (recData.secondMenu.length > 0) {
            recData.secondMenu.forEach((item, index) => {
              if (item.id == this.menuId) {
                choosedItem = item;
                this.linkAddress = item.href ? item.href : "";
              }
            });
          }
          this.total = recData.total;
          this.firstMenuName = recData.firstMenuName;
          console.log("recData", recData)
          this.firstMenuId = recData.menuId;
          this.menuName = recData.menuName;
          this.contentList = recData.dataList;
          if (
            recData.menuName == "仪器预约记录" ||
            recData.menuName == "实验室预约记录" ||
            choosedItem.label == "使用记录" ||
            recData.menuName == "考勤记录" ||
            recData.menuName == "实验室信息" ||
            recData.menuName == "成绩查询" ||
            recData.menuName == "违规扣分处罚信息"
          ) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: recData.menuName,
              },
            });
          } else if (this.total == 1) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: this.contentList[0].title,
              },
            });
          }

          //如果只有一级菜单，就把一级菜单放上。
          if (recData.secondMenu.length == 0) {
            this.menuList = [
              {
                label: recData.firstMenuName,
                id: recData.menuId,
              },
            ];
          } else {
            //多条列表
            this.menuList = recData.secondMenu;
            if (
              choosedItem.label == "仪器预约记录" ||
              choosedItem.label == "实验室预约记录" ||
              choosedItem.label == "使用记录" ||
              choosedItem.label == "考勤记录" ||
              choosedItem.label == "成绩查询" ||
              recData.menuName == "实验室信息" ||
              recData.menuName == "违规扣分处罚信息"
            ) {
              this.$router.push({
                path: "detail:contentId",
                name: "Detail",
                params: {
                  contentId: this.contentList[0].id,
                  label: choosedItem.label,
                },
              });
            }
          }
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
        });
    },
    toDetail(contentId, label,index) {
      this.activeIndex=index;
      this.$router.push({
        path: "detail:contentId",
        name: "Detail",
        params: { contentId: contentId, label: label },
      });
    },
  },
  mounted() {
    this.activeMenuIndex = this.$route.params.menuIndex?this.$route.params.menuIndex:0;
    this.$nextTick(() => {
      if (this.$route.params.menuId) {
        this.menuId = this.$route.params.menuId;
        this.activeMenuIndex=this.$route.params.menuIndex?this.$route.params.menuIndex:0;
        // this.activeMenuIndex = this.$route.params.menuIndex
        this.getSecondList();
      }
    });
    this.getAccessLogNum()
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时执行一次
  },
  beforeEacch(to, from, next) {
    if (this.$route.params.menuId) {
      this.menuId = this.$route.params.menuId;

      this.getSecondList();
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    // if (this.$route.params.menuId) {
    this.menuId = this.$route.params.menuId;
    this.getSecondList();
    // }
  }
}


</script>
<style lang="less" scoped>
.contentBox{
  width: 100%;
  margin: 0 auto;
  padding: 50px 150px;
  display: flex;
  justify-content: space-between;
  min-height: 600px;
  .left-nav{
    width: 360px;
    position: relative;
    height: 600px;
    background: #f2f2f2 url("~@/assets/bg_bottom.png") no-repeat center bottom;
    background-size: contain;
    margin-right: 50px;
    .bg_title{
      width: 100%;
      height: 122px;
      background: url("~@/assets/list/bg1s.png") no-repeat;
      background-size: 100% 100%;
      padding: 25px 0 0 40px;
      margin-bottom: 16px;
    }
  }
  .rightContent{
    width: calc(100% - 410px);
    height: 100%;
    position: relative;
    .box_card {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-content: flex-start;
      flex-wrap: wrap;
      .card_data {
        width: 32%;
        height: 263px;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .active_card {
        width: 32%;
        height: 263px;
        margin-bottom: 20px;
        cursor: pointer;
        border-bottom: 6px solid #176DAA;
      }
    }
  }
}
.titleNav{
  //position: absolute;
  //top: -10%;
}
/deep/.el-card__header{
  padding: 0;
}
/deep/.el-card__body, .el-main{
  padding: 0;
}
.activeBorder{
  //border-bottom: 1px solid rgba(223,227,232,1);
  font-size:20px;
  font-weight:700;
  color:rgba(128,128,128,1);
  cursor: pointer;
  border-left: 4px solid #176DAA;
  color: #176DAA;
  padding-left: 40px;
}
.hoverBorder{
  //border-bottom: 1px solid rgba(223,227,232,1);
  font-size:20px;
  font-weight:400;
  color:#333333;
  cursor: pointer;
  padding-left: 40px;
}
//.hoverBorder :hover{
//  border-left: 4px solid #002b9e;
//  color: #002b9e;
//}
</style>
<style scoped>
.panel{
  transform-origin: center;
  /* 确保子元素也按比例缩放 */
  width: calc(100% / var(--scale-factor));
  height: calc(100% / var(--scale-factor));
  transform: scale(var(--scale-factor));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(var(--scale-factor));
}
.el-divider--horizontal{
  width: calc(100% - 80px);
  margin: 16px auto !important;
}
.bottomLink {
  height: 60px;
  width: 100%;
  /* width: calc(100% - 520px); */
  background: #105C93;
  color: #fff;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 40px 260px;
  background: url("../assets/bottomBgs.png") no-repeat;
  background-size: 100% 100%;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 16px;
}
</style>
